module.exports = __webpack_public_path__ + "static/media/circle-minus.ded10cb9.svg";